import { createAddBonusModal } from 'features/add-bonus';
import { createBlockBonusModal } from 'features/block-bonus';
import { createDeleteBonusModal } from 'features/delete-bonus';
import { createEditBonusModal } from 'features/edit-bonus';
import { createBonusRegistry } from 'entities/bonus';
import { accountPageBonusModel } from '../../model';
import cls from './account-page-bonus.module.scss';

const BonusRegistry = createBonusRegistry(accountPageBonusModel.bonusRegistryModel);

const AddBonusModal = createAddBonusModal(accountPageBonusModel.addBonusModel);

const EditBonusModal = createEditBonusModal(accountPageBonusModel.editBonusModel);

const BlockBonusModal = createBlockBonusModal(accountPageBonusModel.blockBonusModel);

const UnblockBonusModal = createBlockBonusModal(accountPageBonusModel.unblockBonusModel);

const DeleteBonusModal = createDeleteBonusModal(accountPageBonusModel.deleteBonusModel);

export const AccountPageBonus = () => (
	<>
		<BonusRegistry
			className={cls.accountPageBonusRegistry}
			withTitle={false}
			withAccount={false}
			topBarActionSlot={<AddBonusModal.Button />}
			tableTdActionSlot={(bonus) => (
				<div className={cls.accountPageBonusActions}>
					<EditBonusModal.ActionIcon modalData={bonus} />
					{bonus.isLocked ? (
						<UnblockBonusModal.ActionIcon modalData={bonus} />
					) : (
						<BlockBonusModal.ActionIcon modalData={bonus} />
					)}
					<DeleteBonusModal.ActionIcon modalData={bonus} />
				</div>
			)}
			emptyActionSlot={<AddBonusModal.Button />}
		/>
		<AddBonusModal />
		<EditBonusModal />
		<BlockBonusModal />
		<UnblockBonusModal />
		<DeleteBonusModal />
	</>
);
